import { EnterprisePlaylistState, enterprisePlaylistInitialState } from './State'

import { TOGGLE_IS_LOADING, SET_PLAYLIST_DATA, RESET, SET_INFO_LOADED_STATE, EnterprisePlaylistAction } from './Actions'

function enterprisePlaylistReducer(
  state: EnterprisePlaylistState,
  action: EnterprisePlaylistAction
): EnterprisePlaylistState {
  switch (action.type) {
    case TOGGLE_IS_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case SET_PLAYLIST_DATA:
      return {
        ...state,
        loadedInfoState: action.payload.infoState,
        playlist: action.payload.data
      }
    case SET_INFO_LOADED_STATE:
      return {
        ...state,
        loadedInfoState: action.payload
      }
    case RESET:
      return enterprisePlaylistInitialState
    default:
      return state
  }
}

export default enterprisePlaylistReducer
